<div class="event__sponsors" *ngIf="showSponsors">
    <div id="sponsors" class="row justify-content-center m-0">
      <div class="section__sponsors_title w-100">Sponsors</div>
      <app-event-page-sponsors-item *ngFor="let sponsor of sponsors" [sponsor]="sponsor"></app-event-page-sponsors-item>
    </div>
</div>    